import { adminServerInstance, appMainServerInstance, driverServerInstance, deliveryServerInstance } from "../axios/instances";
import { BASIC_INFO_LOAD, BASIC_INFO_LOAD_SUCCESS, BASIC_INFO_LOAD_FAIL, EDIT_ORDER_ADDRESS, EDIT_ORDER_ADDRESS_SUCCESS, EDIT_ORDER_ADDRESS_FAIL } from './driverTypes.js';
import { ORDER_INFO_LOAD, ORDER_INFO_LOAD_SUCCESS, ORDER_INFO_LOAD_FAIL } from './driverTypes.js';
import { ORDER_INFO_UPDATE, ORDER_INFO_UPDATE_SUCCESS, ORDER_INFO_UPDATE_FAIL } from './driverTypes.js';
import { ORDER_INFO_DETAIL_LOAD, ORDER_INFO_DETAIL_LOAD_SUCCESS, ORDER_INFO_DETAIL_LOAD_FAIL } from './driverTypes.js';
import { NEXT_TRANSITION_LOAD, NEXT_TRANSITION_LOAD_SUCCESS, NEXT_TRANSITION_LOAD_FAIL} from './driverTypes.js';
import { OPEN_FIELD_CHANGE_DIALOG, OPEN_DRIVER_TRANSFER_DIALOG, OPEN_SECONDARY_DELIVERY_DIALOG } from './driverTypes.js';
import { ORDER_SIGNATURE_PHOTO_LOAD, ORDER_SIGNATURE_PHOTO_LOAD_SUCCESS, ORDER_SIGNATURE_PHOTO_LOAD_FAIL } from './driverTypes.js';
import { ORDER_SIGNATURE_PHOTO_UPDATE, ORDER_SIGNATURE_PHOTO_UPDATE_SUCCESS, ORDER_SIGNATURE_PHOTO_UPDATE_FAIL } from './driverTypes.js';
import { INSERT_DRIVER_ORDER, INSERT_DRIVER_ORDER_SUCCESS, INSERT_DRIVER_ORDER_FAIL} from './driverTypes.js'
import { UPDATE_SCAN_STATUS, UPDATE_SCAN_STATUS_SUCCESS, UPDATE_SCAN_STATUS_FAIL} from './driverTypes.js'
import { CREATE_SECONDARY_DELIVERY, CREATE_SECONDARY_DELIVERY_SUCCESS, CREATE_SECONDARY_DELIVERY_FAIL} from './driverTypes.js'
import { ADD_CUSTOM_COMPLAIN, ADD_CUSTOM_COMPLAIN_SUCCESS, ADD_CUSTOM_COMPLAIN_FAIL} from './driverTypes.js'
import { GET_NEW_STORAGE_INFO, GET_NEW_STORAGE_INFO_SUCCESS, GET_NEW_STORAGE_INFO_FAIL } from './driverTypes.js'
import { GET_EXCEPTION_DETAILS, GET_EXCEPTION_DETAILS_SUCCESS, GET_EXCEPTION_DETAILS_FAIL, GET_EXCEPTION_BY_STATE, GET_EXCEPTION_BY_STATE_SUCCESS, GET_EXCEPTION_BY_STATE_FAIL } from './driverTypes.js'
import { EDIT_EXCEPTION, EDIT_EXCEPTION_SUCCESS, EDIT_EXCEPTION_FAIL } from './driverTypes.js'
import { UPDATE_SHIPPING_STATUS, UPDATE_SHIPPING_STATUS_FAIL, UPDATE_SHIPPING_STATUS_SUCCESS } from "./editOrderTypes";
import { GET_DRIVER_SCAN_RECORD, GET_DRIVER_SCAN_RECORD_SUCCESS, GET_DRIVER_SCAN_RECORD_FAIL } from "./editOrderTypes";
import { UPDATE_SHIPPING_STATUS_SIMPLE, UPDATE_SHIPPING_STATUS_SIMPLE_SUCCESS, UPDATE_SHIPPING_STATUS_SIMPLE_FAIL } from "./editOrderTypes";
import { GET_RETRY_POD, GET_RETRY_POD_SUCCESS, GET_RETRY_POD_FAIL } from "./editOrderTypes";
import { SWITCH_RETRY, SWITCH_RETRY_SUCCESS, SWITCH_RETRY_FAIL } from "./editOrderTypes";
import { GET_FAILED_REASON, GET_FAILED_REASON_SUCCESS, GET_FAILED_REASON_FAIL } from "./editOrderTypes";
import { REVERT_ORDER_PATH_STATE, REVERT_ORDER_PATH_STATE_FAIL, REVERT_ORDER_PATH_STATE_SUCCESS } from "./types";
import { UPDADE_ORDER_POD, UPDADE_ORDER_POD_SUCCESS, UPDADE_ORDER_POD_FAIL } from "./types";
import { DELETE_ORDER_POD, DELETE_ORDER_POD_SUCCESS, DELETE_ORDER_POD_FAIL } from "./types";
import { GET_ORDER_POD, GET_ORDER_POD_SUCCESS, GET_ORDER_POD_FAIL } from "./types";
import { ORDER_JUMP_IN_LINE_TRANSFER, ORDER_JUMP_IN_LINE_TRANSFER_SUCCESS, ORDER_JUMP_IN_LINE_TRANSFER_FAIL } from "./driverTypes";
import { DELIVERY_OPERATION, DELIVERY_OPERATION_SUCCESS, DELIVERY_OPERATION_FAIL } from "./driverTypes";
import { GET_CUSTOMER_COMPLAIN_REASON, GET_CUSTOMER_COMPLAIN_REASON_FAIL, GET_CUSTOMER_COMPLAIN_REASON_SUCCESS } from "./editOrderTypes";
import { GET_CUSTOMER_COMPLAIN, GET_CUSTOMER_COMPLAIN_SUCCESS, GET_CUSTOMER_COMPLAIN_FAIL } from "./editOrderTypes";
import { CREATE_CUSTOMER_COMPLAIN, CREATE_CUSTOMER_COMPLAIN_FAIL, CREATE_CUSTOMER_COMPLAIN_SUCCESS } from "./editOrderTypes";
import { UPDATE_SIGNATURE_REQUIRED, UPDATE_SIGNATURE_REQUIRED_FAIL, UPDATE_SIGNATURE_REQUIRED_SUCCESS } from "./editOrderTypes";
import { UPDATE_FAILED_REASON, UPDATE_FAILED_REASON_FAIL, UPDATE_FAILED_REASON_SUCCESS } from "./editOrderTypes";
import encryptRSA from "../ssl/encrypt";

/**
 * @param {object} params
 * @param {string} tno
 * @param {boolean} isRequired
 */
export function updateSignatureRequiredInfo(tno, isRequired) {
    return function (dispatch) {
        dispatch({ type: UPDATE_SIGNATURE_REQUIRED })
        return adminServerInstance.get(`/orders/updatesignaturerequiredinfo?tno=${tno}&isRequired=${isRequired}`)
            .then(({ data }) => {
                dispatch({
                    type: UPDATE_SIGNATURE_REQUIRED_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: UPDATE_SIGNATURE_REQUIRED_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * @param {object} params
 * @param {string} tno
 * @param {string} fresh_desk_ticket
 * @param {string} complain_reason_id
 */
export function createCustomerComplain(params) {
    return function (dispatch) {
        dispatch({ type: CREATE_CUSTOMER_COMPLAIN })
        return adminServerInstance.post(`/customercomplain/complain`, params)
            .then(({ data }) => {
                dispatch({
                    type: CREATE_CUSTOMER_COMPLAIN_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: CREATE_CUSTOMER_COMPLAIN_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getCustomerComplain(tno) {
    return function (dispatch) {
        dispatch({ type: GET_CUSTOMER_COMPLAIN })
        return adminServerInstance.get(`/customercomplain/complain?tno=${tno}`)
            .then(({ data }) => {
                dispatch({
                    type: GET_CUSTOMER_COMPLAIN_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_CUSTOMER_COMPLAIN_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getCustomerComplainReason() {
    return function (dispatch) {
        dispatch({ type: GET_CUSTOMER_COMPLAIN_REASON })
        return adminServerInstance.get('/customercomplain/reason')
            .then(({ data }) => {
                dispatch({
                    type: GET_CUSTOMER_COMPLAIN_REASON_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_CUSTOMER_COMPLAIN_REASON_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * @param {string} order_id
 */
export function getOrderPod(order_id) {
    return function(dispatch) {
        dispatch({type: GET_ORDER_POD})
        return deliveryServerInstance.get(`/delivery/parcels/pods/${order_id}`)
        .then(({data}) => {
            dispatch({
                type: GET_ORDER_POD_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
              type: GET_ORDER_POD_FAIL,
              payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {string} order_id
 * @param {string} file_id
 */
export function deleteOrderPod(params) {
    return function(dispatch) {
        dispatch({type: DELETE_ORDER_POD})
        return deliveryServerInstance.delete(`/delivery/parcels/pods/${params.order_id}/${params.file_id}`)
        .then(({data}) => {
            dispatch({
                type: DELETE_ORDER_POD_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
              type: DELETE_ORDER_POD_FAIL,
              payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {string} order_id
 * @param {string} reason
 */
export function updateFailedReason(orderId, reason, warehouse) {
    return function (dispatch) {
        dispatch({ type: UPDATE_FAILED_REASON })
        return deliveryServerInstance.put(`/delivery/parcels/failed-reasons/${orderId}`, {
            'failed_reason': reason
        }, {
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, warehouse)
            }
        })
            .then(({ data }) => {
                dispatch({
                    type: UPDATE_FAILED_REASON_SUCCESS,
                    payload: data.biz_data
                })
                return Promise.resolve(data.biz_data);
            }).catch(error => {
                dispatch({
                    type: UPDATE_FAILED_REASON_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

/**
 * @param {string} order_id
 * @param {string} delivery_result // 0->succss, 1->failure
 * @param {document} pod_images[]
 */
export function deliveryOperation(formData, warehouse) {
    return function(dispatch) {
        dispatch({type: DELIVERY_OPERATION})
        return deliveryServerInstance.post(`/delivery/secure`, formData, {
            headers: {
                'Client-id': 'UMMN',
                "Sig-token": encryptRSA(process.env.REACT_APP_RSA_PRIVACY_KEY, warehouse)
            }
        })
        .then(({data}) => {
            dispatch({
                type: DELIVERY_OPERATION_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
              type: DELIVERY_OPERATION_FAIL,
              payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {string} order_id
 * @param {document} pod_images[]
 */
export function updateOrderPod(formData) {
    return function(dispatch) {
        dispatch({type: UPDADE_ORDER_POD})
        return deliveryServerInstance.post(`/delivery/parcels/pods`, formData)
        .then(({data}) => {
            dispatch({
                type: UPDADE_ORDER_POD_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
              type: UPDADE_ORDER_POD_FAIL,
              payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {string} TNO
 * @param {number} RetryStatus
 */
 export function switchRetry(tno, retryStatus) {
    return function(dispatch) {
        dispatch({type: SWITCH_RETRY})
        return adminServerInstance.put(`/orders/switchretry/${tno}/${retryStatus}`)
        .then(({data}) => {
            dispatch({
                type: SWITCH_RETRY_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
              type: SWITCH_RETRY_FAIL,
              payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {*} order_id 
 */
export function getRetryPod(orderId) {
    return function(dispatch) {
        dispatch({type: GET_RETRY_POD})
        return driverServerInstance.get(`/delivery/retry/pods/${orderId}`)
        .then(({data}) => {
            dispatch({
                type: GET_RETRY_POD_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
              type: GET_RETRY_POD_FAIL,
              payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - Combined object to send for server processing
 * @param {number} params.staff_id - NEXT_TRANSITION_STAFF_ID -> 666
 * @param {string} params.scan_location - Operation warehouse long name
 * @param {number} [params.storaged_warehouse] - Operation warehouse ID
 * @param {number} [params.send_sms] - 0: not send / 1: send
 * @param {number} [params.shipping_status] - 0, 1, 2
 * @param {string} [params.exception] - Exception code
 * @param {string} [params.order_id] - Order ID
 * @param {object} [params.parcel_info] - Including extra_order_sn(string), transition(string), order_id(string), status(number), desc(string), warehouse(number)
*/
export function updateShippingStatusSimple(params){
    return function(dispatch) {
        dispatch({type: UPDATE_SHIPPING_STATUS_SIMPLE})
        return adminServerInstance.post('/driver/updateshippingstatus', {
            ...params
        }).then(({data}) => {
            dispatch({
                type: UPDATE_SHIPPING_STATUS_SIMPLE_SUCCESS,
                payload: data,
            })
            return Promise.resolve(data.data)
        }).catch(error => {
            dispatch({
                type: UPDATE_SHIPPING_STATUS_SIMPLE_FAIL,
                payload: error,
            })   
            return Promise.reject(error)
        })
    }
}

export function getDriverScanRecord(order_id) {
    return function(dispatch) {
        dispatch({type: GET_DRIVER_SCAN_RECORD})
        return deliveryServerInstance.get(`/delivery/parcels/scan-journals/${order_id}`)
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_SCAN_RECORD_SUCCESS,
                payload: data.biz_data,
            })   
            return Promise.resolve(data.biz_data); 
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_SCAN_RECORD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * Update exception
 */
 export function editException(order_id, exception) {
    return function(dispatch) {
        dispatch({type: EDIT_EXCEPTION})
        return appMainServerInstance.post(`/business/editexception?order_id=${order_id}&exception=${exception}`)
        .then(({data}) => {
            dispatch({
                type: EDIT_EXCEPTION_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: EDIT_EXCEPTION_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * Get exception details
 */
 export function getExceptionDetails() {
    return function(dispatch) {
        dispatch({type: GET_EXCEPTION_DETAILS})
        return appMainServerInstance.get(`/business/getexceptiondetails`)
        .then(({data}) => {
            dispatch({
                type: GET_EXCEPTION_DETAILS_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: GET_EXCEPTION_DETAILS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getExceptionByState(state) {
    return function(dispatch) {
        dispatch({type: GET_EXCEPTION_BY_STATE})
        return appMainServerInstance.get(`/business/getexceptiondetails?state=${state}`)
        .then(({data}) => {
            dispatch({
                type: GET_EXCEPTION_BY_STATE_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: GET_EXCEPTION_BY_STATE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * get the newest order position
 * . order position
 * . exception error list
 */
 export function getNewStorageInfo(warehouse) {
    return function(dispatch) {
        dispatch({type: GET_NEW_STORAGE_INFO})
        return adminServerInstance.get(`/business/getnewstorageinfo?warehouse=${warehouse}`)
        .then(({data}) => {
            dispatch({
                type: GET_NEW_STORAGE_INFO_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: GET_NEW_STORAGE_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * get the basic info
 * . warehouse info
 * . exception error list
 */
 export function getBasicInfo() {
    return function(dispatch) {
        dispatch({type: BASIC_INFO_LOAD})
        return adminServerInstance.get(`map/getbasicinfo`)  
        .then(({data}) => {
            dispatch({
                type: BASIC_INFO_LOAD_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: BASIC_INFO_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}


/**
 * 
 * @param {*} searchId 
 * @param {*} searchType 
 */
export function getOrderInfo(searchId,searchType) {
    //let queryCondition = "map/getorderdetail?" + `${searchType}` + "=" + `${searchId}`;
    return function(dispatch) {
        dispatch({type: ORDER_INFO_LOAD})
        return adminServerInstance.get(`map/getorderdetail?${searchType}=${searchId}`)  
        .then(({data}) => {
            dispatch({
                type: ORDER_INFO_LOAD_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: ORDER_INFO_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * update with the changed field
 * @param {} params 
 */
export function updateOrderInfo(orderId, params) {
    return function(dispatch) {
        dispatch({type: ORDER_INFO_UPDATE})
        return adminServerInstance.post(`map/editorder`, {
            order_id: orderId ,
            ...params
        })  .then(({data}) => {
            dispatch({
                type: ORDER_INFO_UPDATE_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: ORDER_INFO_UPDATE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * 
 * @param {*} orderId 
 */
export function getOrderSignature(orderId) {
    return function(dispatch) {
        dispatch({type: ORDER_SIGNATURE_PHOTO_LOAD})
        return adminServerInstance.get(`orders/getsignaturenew?order_sn=${orderId}`)  
        .then(({data}) => {
            dispatch({
                type: ORDER_SIGNATURE_PHOTO_LOAD_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: ORDER_SIGNATURE_PHOTO_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * @param {Object} formData - combined object to send for server processing
 * @param {string} formData.order_sn 
 * @param {string} formData.signer
 * @param {Number} formData.drop_off // 1
 * @param {string} formData.vcode // 'KCSZ9NXanI8lT'
 * @param {string} formData.barcode_scanned
 * @param {Number} formData.is_addon // 1
 * @param {file} formData.signature
 */
export function uploadOrderSignature(params) {
    return function(dispatch) {        
        dispatch({type: ORDER_SIGNATURE_PHOTO_UPDATE})
        return adminServerInstance.post(`orders/uploadsignaturenew`, params)  
        .then(({data}) => {
            dispatch({
                type: ORDER_SIGNATURE_PHOTO_UPDATE_SUCCESS,
                payload: data,
            })   
            getOrderSignature(params.order_sn);
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: ORDER_SIGNATURE_PHOTO_UPDATE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}



/**
 * get the detail information which is useful to tech debuging
 */
export function getOrderInfoDetail(orderId) {
    return function(dispatch) {
        dispatch({type: ORDER_INFO_DETAIL_LOAD})
        return adminServerInstance.get(`map/getorderdetailall?order_id=${orderId}`)  
        .then(({data}) => {
            dispatch({
                type: ORDER_INFO_DETAIL_LOAD_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: ORDER_INFO_DETAIL_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * Jump in line for transfer order to driver
 */
export function orderJumpInLineTransferToDriver(trackingNo, driverId) {
    return function(dispatch) {
        dispatch({type: ORDER_JUMP_IN_LINE_TRANSFER})   
        return deliveryServerInstance.put(`/delivery/ext/parcels/assign/${trackingNo}`, {
            driver_id: driverId
        })  
        .then(({data}) => {
            dispatch({
                type: ORDER_JUMP_IN_LINE_TRANSFER_SUCCESS,
                payload: data.biz_data,
            })   
            return Promise.resolve(data.biz_data); 
        }).catch(error => {
            dispatch({
                type: ORDER_JUMP_IN_LINE_TRANSFER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * Jump in line for inserting order to the planning route of the driver
 */
export function orderJumpInLineAddToRoute(orderId, driverId, memo) {
    return function(dispatch) {
        dispatch({type: INSERT_DRIVER_ORDER})   
        return adminServerInstance.post(`map/insertdriverorder`, {
            driver_id: driverId,
            order_id: orderId,
            driver_notes: memo
        })  
        .then(({data}) => {
            dispatch({
                type: INSERT_DRIVER_ORDER_SUCCESS,
                payload: data.status,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: INSERT_DRIVER_ORDER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * get the next available transition for the next operation
 * @param {} currentState 
 */
export function getNextTransition(currentState) {
    return function(dispatch) {
        dispatch({type: NEXT_TRANSITION_LOAD})
        return adminServerInstance.get(`map/getnexttransition?current_state=${currentState}`)  
        .then(({data}) => {
            dispatch({
                type: NEXT_TRANSITION_LOAD_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: NEXT_TRANSITION_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}


/**
 * Next Transition Submit
 */
export function nextTransitionSubmit(params) {
    return function(dispatch) {        
        dispatch({type: UPDATE_SCAN_STATUS})
        return adminServerInstance.post(`/driver/updatescanstatus`, params)  
        .then(({data}) => {
            dispatch({
                type: UPDATE_SCAN_STATUS_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: UPDATE_SCAN_STATUS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * update shipping status and transition
 * @param {Object} params
 * @param {string} params.order_id
 * @param {number} params.staff_id
 * @param {number} params.shipping_status - 0/1/2
 * @param {string} params.scan_location
 * @param {Object} parcelInfo
 */
export function updateShippingStatus(params, parcelInfo, exception_id, failedReasonId){
    return function(dispatch) {
        dispatch({type: UPDATE_SHIPPING_STATUS})
        return adminServerInstance.post('/driver/updateshippingstatus', {
            ...params,
            parcel_info: parcelInfo,
            exception: exception_id,
            failed_reason: failedReasonId
        }).then(({data}) => {
            dispatch({
                type: UPDATE_SHIPPING_STATUS_SUCCESS,
                payload: data,
            })
            return Promise.resolve(data.data)
        }).catch(error => {
            dispatch({
                type: UPDATE_SHIPPING_STATUS_FAIL,
                payload: error,
            })   
            return Promise.reject(error)
        })
    }
}

export function getFailedReason(){
    return function(dispatch) {
        dispatch({type: GET_FAILED_REASON})
        return deliveryServerInstance.get('/masterdata/delivery/failed-reasons').then(({data}) => {
            dispatch({
                type: GET_FAILED_REASON_SUCCESS,
                payload: data.biz_data,
            })
            return Promise.resolve(data.biz_data)
        }).catch(error => {
            dispatch({
                type: GET_FAILED_REASON_FAIL,
                payload: error,
            })   
            return Promise.reject(error)
        })
    }
}


/**
 * control the field change dialog
 * @param {} isOpen 
 */
export function openFieldChangeDialog(isOpen) {
    return function(dispatch) {
        dispatch({
            type: OPEN_FIELD_CHANGE_DIALOG,
            payload: isOpen,
        })
    }
}

/**
 * control the driver transfer dialog
 */
export function openDriverTransferDialog(isOpen) {
    return function(dispatch) {
        dispatch({
            type: OPEN_DRIVER_TRANSFER_DIALOG,
            payload: isOpen,
        })
    }    
}

/**
 * control the Secondary Delivery dialog
 * @param {} isOpen 
 */
export function openSecondaryDeliveryDialog(isOpen) {
    return function(dispatch) {
        dispatch({
            type: OPEN_SECONDARY_DELIVERY_DIALOG,
            payload: isOpen,
        })
    }
}

/**
 * Create secondary delivery
 * @param {Object} params
 * @param {string} params.trace_no // Optional
 * @param {string} params.price
 * @param {string} params.apt_no
 * @param {string} params.buzz_code
 * @param {string} params.postscript
 * @param {string} params.storage_info
 * @param {Number} params.version // 1
 */
export function createSecondaryDelivery(params) {
    return function(dispatch) {
        dispatch({type: CREATE_SECONDARY_DELIVERY})
        return adminServerInstance.post(`business/createsecondelivery`, params)  
        .then(({data}) => {
            dispatch({
                type: CREATE_SECONDARY_DELIVERY_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: CREATE_SECONDARY_DELIVERY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * add custom complain
 * @param {Object} params
 * @param {string} params.order_id
 * @param {string} params.note
 * @param {Number} params.is_complained // 1
 * @param {Number} params.driver_id
 */
export function addCustomComplain(params) {
    return function(dispatch) {
        dispatch({type: ADD_CUSTOM_COMPLAIN})        
        return adminServerInstance.post(`map/addcsnote`, params)  
        .then(({data}) => {
            dispatch({
                type: ADD_CUSTOM_COMPLAIN_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: ADD_CUSTOM_COMPLAIN_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

export function editOrderAddress(orderId, address, api, optional){
    return function(dispatch) {
        dispatch({type: EDIT_ORDER_ADDRESS})        
        return adminServerInstance.post(`map/editorderaddress`, {
            order_id: orderId,
            address: address,
            type: api,
            ...optional
        }).then(({data}) => {
            dispatch({
                type: EDIT_ORDER_ADDRESS_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: EDIT_ORDER_ADDRESS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}
export function revertLastPathState(orderId){
    return function (dispatch){
        dispatch({type: REVERT_ORDER_PATH_STATE})
        return adminServerInstance.post(`/driver/revertlaststate`, {
            order_id: orderId
        })
            .then(({data}) => {
                dispatch({
                    type: REVERT_ORDER_PATH_STATE_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data);
            }).catch(error=> {
                dispatch({
                    type: REVERT_ORDER_PATH_STATE_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}